import { HttpStatusCode } from 'axios';
import { EventBus } from '../../../event';
import { Tags } from '../../../web';
import { Interceptor, InterceptorRequestConfig, IResponse } from '../http.service';
import { isRequestTimeouted } from './timeout-request-interceptor';

export const RequestStatusCode401OccuredEvent = Symbol('shared:request-status-code-401-occured');

export function handle401StatusRequestInterceptor(): Interceptor {
	let isUnauthorized = false;
	let eventEmmited = false;

	return {
		request: (config: InterceptorRequestConfig) => {
			if (isUnauthorized && config.taggedUrl.hasAnyTag([Tags.Api, Tags.SelloApi])) {
				Promise.resolve();
			}
		},
		responseError: (error: IResponse) => {
			if (!isRequestTimeouted(error) && (error.response?.status === HttpStatusCode.Unauthorized)) {
				isUnauthorized = true;
				const shouldEmitEvent = !eventEmmited && !error.config.taggedUrl.hasTag(Tags.OmitMessage);

				if (shouldEmitEvent) {
					eventEmmited = true;
					EventBus.emit(RequestStatusCode401OccuredEvent);
				}
			}
		}
	};
}
